import React, { useEffect, useState } from "react"

import { GetInternPopularBody } from "~/api/intern/popular/_types"
import { fetchGetInternPopular } from "~/api/intern/popular/get"
import Button from "~/components/atoms/Button"
import Typography from "~/components/atoms/Typography"
import Carousel from "~/components/molecules/Carousel"
import JobCardPopularLongInternship from "~/components/molecules/JobCardPopularLongInternship"

import * as Styled from "./styled"

const INFRA_INTERN_LONG_INTERNSHIPS = `${process.env.INFRA_INTERN_URL}/long-internships`
const INFRA_INTERN_SEARCH_BUSINESS_LINK = `${process.env.INFRA_INTERN_URL}/long-internships?occupation%5B%5D=3&occupation%5B%5D=4&occupation%5B%5D=5&occupation%5B%5D=6&occupation%5B%5D=10&occupation%5B%5D=7`

const customCarouselSettings = {
  arrows: false,
  dots: true,
  autoplay: false,
  infinite: true,
  swipeToSlide: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [{ breakpoint: 500, settings: { slidesToShow: 2 } }],
}

export const AuthRegisterCompleteLongInternship: React.FC = () => {
  const [interns, setInterns] = useState<Array<GetInternPopularBody>>([])

  useEffect(() => {
    onMount()
  }, [])

  const onMount = async () => {
    const result = await fetchGetInternPopular()
    if ("error" in result) return
    setInterns(result)
  }

  const toLongInternship = (path: string = "") => {
    window.location.href = `${INFRA_INTERN_LONG_INTERNSHIPS}${path}?access_from=registration-complete`
  }

  const handleClickHref = (path: string) => {
    window.location.href = `${path}?access_from=registration-complete`
  }

  return (
    <Styled.AuthRegisterCompleteLongInternshipContainer>
      <Styled.SubTitle type="Note">
        さあ、Infra であなたにぴったりの
        <br />
        長期インターンを見つけよう！
      </Styled.SubTitle>

      {Boolean(interns.length) && (
        <div className="popular-container">
          <Typography type="Heading">人気の長期インターン</Typography>
          <div className="popular-carousel">
            <Carousel settings={customCarouselSettings}>
              {interns.map((intern) => (
                <div className="popular-carousel-item" key={intern.id}>
                  <JobCardPopularLongInternship intern={intern} onClick={handleClickHref} />
                </div>
              ))}
            </Carousel>
          </div>
          <Button size="Small" className="popular-more-button" onClick={toLongInternship}>
            長期インターンをもっとみる
          </Button>
        </div>
      )}

      <div className="terms-container">
        <div className="terms-container-inner">
          <Typography className="term-title" type="Heading">
            希望の条件から探す
          </Typography>
          <div className="term-group">
            <Typography className="term-label" type="Label">
              職種から探す
            </Typography>
            <div className="term-list">
              <div className="term" onClick={() => toLongInternship("/occupations/1")}>
                エンジニア職
              </div>
              <div className="term" onClick={() => toLongInternship("/occupations/2")}>
                デザイナー職
              </div>
              <div className="term" onClick={() => handleClickHref(INFRA_INTERN_SEARCH_BUSINESS_LINK)}>
                ビジネス職
              </div>
            </div>
          </div>
          <div className="term-group">
            <Typography className="term-label" type="Label">
              特徴から探す
            </Typography>
            <div className="term-list">
              <div className="term" onClick={() => toLongInternship("/features/1")}>
                週3日以下でOK
              </div>
              <div className="term" onClick={() => toLongInternship("/features/22")}>
                フルリモート可
              </div>
              <div className="term" onClick={() => toLongInternship("/features/4")}>
                1・2年生歓迎
              </div>
            </div>
          </div>
          <div className="term-group">
            <Typography className="term-label" type="Label">
              エリアから探す
            </Typography>
            <div className="term-list">
              <div className="term" onClick={() => toLongInternship("/prefectures/13")}>
                東京都全域
              </div>
              <div className="term" onClick={() => toLongInternship("/areas/6")}>
                関西
              </div>
              <div className="term" onClick={() => toLongInternship("/areas/7")}>
                その他（国内）
              </div>
            </div>
          </div>
        </div>
      </div>
    </Styled.AuthRegisterCompleteLongInternshipContainer>
  )
}
